import { Col, Form } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { IncreasingNumber } from '../IncreasingNumber/IncreasingNumber'

export const BuybackFormSummaryFragmentBuyback: FunctionComponent = memo(() => {
  const buybackPrice = Form.useWatch(FIELD.BuybackPrice) ?? 0

  return (
    <Col xs={24} md={12} xl={8} className="text-center">
      <div className="mb-2">Garantovaná výše zpětného odkupu</div>
      <IncreasingNumber
        className="text-2xl"
        finalNumber={buybackPrice}
        decimal={0}
        suffix=" Kč"
      />
    </Col>
  )
})
